<template>
  <div class="sidebar menu">
    <div class="row">
      <div class="col logo">
        <router-link :to="{name: 'MAIN_A'}" class="logo" @click.native="routerMainPageClickHandler" title="권규호국어연구실"></router-link>
      </div>
      <!-- <div class="col profile">
        <a href="#" title="Profile" class="admin profile" @click.prevent="logout"></a>
      </div> -->
    </div>

    <div class="main_menu">
      <el-menu
        :default-openeds="defaultOpeneds"
        :default-active="defaultActive"
        :router="isRouter"
        :unique-opened="isUniqueOpen"
        class="el-menu-vertical-demo"
        @select="selectedMenu"
        >
        <template v-for="menu in localMenus">
          <template v-if="menu.lvl === 1">
            <template v-if="menu.is_leaf === 0">
               <el-submenu :key="menu.menu_code" :index="menu.menu_code" >
                 <template slot="title">
                   <i :class="menu.class_name"></i>
                   {{menu.menu_name}}
                 </template>
                 <template v-for="sub in localMenus">
                  <el-menu-item v-if="sub.parent_code === menu.menu_code" :key="sub.menu_code" :index="sub.menu_code" :route="{name: sub.menu_link}">
                    {{sub.menu_name}}
                  </el-menu-item>
                 </template>
               </el-submenu>
            </template>
            <template v-else>
              <el-menu-item :key="menu.menu_code" :index="menu.menu_code" :route="{name: menu.menu_link}">
                <i :class="menu.class_name"></i>
                {{menu.menu_name}}
              </el-menu-item>
            </template>
          </template>
        </template>
      </el-menu>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    menus: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data () {
    return {
      localMenus: this.menus,
      defaultOpeneds: [],
      defaultActive: '',
      isRouter: true,
      isUniqueOpen: true
    }
  },
  created () {
    this.defaultActive = this.$route.meta.page !== '' ? this.$route.meta.page : ''
    this.defaultOpeneds = this.$route.meta.parent_page !== '' ? [this.$route.meta.parent_page] : []
  },
  methods: {
    logout () {
      this.$confirm('로그아웃 하시겠습니까?', '', {
      }).then(() => {
        const userType = this.$store.getters.user_type
        this.$store.dispatch('AUTH_LOGOUT').then(() => {
          this.$router.push({name: 'LOGIN_' + userType})
          // window.location.href = '/'
        })
      }).catch(() => {
        // this.$message('취소')
      })
    },
    routerMainPageClickHandler () {
      this.defaultActive = ''
      this.defaultOpeneds = []
      // 강제로 해당 메뉴 activeIndex 값을 찾아서 지워준다.
      const active = this.$children.find(e => e.activeIndex)
      if (active) {
        active.activeIndex = ''
      }
    },
    selectedMenu (index, indexPath) {
      if (indexPath.length === 1) {
        this.defaultOpeneds = []
      }
    }
  },
  watch: {
    menus: function (value) {
      this.localMenus = value
    }
  }
}
</script>

<style scoped="scoped">
  .main_menu {
    height: 100%;
  }

  .el-menu-vertical-demo {
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/menu-list/menu-list.vue